<template>
  <div> 

    <div class="others_header il-bc-chrome" v-if="!hideIndexChrome">
      <nav class="bc-top-nav bc-top-nav--in">
        <div class="bc-top-nav__inner">
          <div class="bc-lang">
            <button
              type="button"
              class="bc-lang__btn"
              :class="{ 'bc-lang__btn--active': $getLocale() === 'en-US' }"
              @click="layoutSetLangEn"
            >
              EN
            </button>
            <button
              type="button"
              class="bc-lang__btn"
              :class="{ 'bc-lang__btn--active': $getLocale() === 'zh-CN' }"
              @click="layoutSetLangZh"
            >
              CN
            </button>
          </div>
          <button
            v-if="$route.path === '/sai-data-list'"
            type="button"
            class="bc-apply-records-btn"
            @click="layoutGoApplyList"
          >
            {{ $T('我的报名记录') }}
          </button>
          <button type="button" class="bc-menu-trigger" aria-label="menu" @click="layoutMenuOpen = true">
            <svg class="bc-menu-trigger__icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path
                d="M4 6h16M4 12h16M4 18h16"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </nav>

      <section class="bc-hero bc-hero--inner">
        <div class="bc-hero__bg">
          <img :src="slideMenuBg" alt="" class="bc-hero__bg-img" />
        </div>
        <div class="bc-hero__logo bc-hero__logo--in">
          <button type="button" class="bc-hero__logo-btn" @click="layoutGoHome">
            <img :src="footerLogoUrl" alt="Trampoline Gymnastics World Championships Nanjing 2026" />
          </button>
        </div>
      </section>
    </div>
    <router-view></router-view>
    <BcSlideMenu
      v-if="!hideIndexChrome"
      :visible.sync="layoutMenuOpen"
      :bg-image="slideMenuBg"
      :items="slideMenuItems"
      label-mode="i18n"
      @select="onLayoutSlideMenuSelect"
    />
    <footer class="bc-footer" v-if="this.$route.name != 'Login' && !hideIndexChrome">
      <div class="bc-footer__deco" aria-hidden="true">
        <svg class="bc-footer__wave" viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path
            fill="rgba(43,123,191,0.3)"
            d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,112C672,96,768,96,864,112C960,128,1056,160,1152,160C1248,160,1344,128,1392,112L1440,96L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
          />
        </svg>
        <div class="bc-footer__circle bc-footer__circle--1"></div>
        <div class="bc-footer__circle bc-footer__circle--2"></div>
        <div class="bc-footer__circle bc-footer__circle--3"></div>
        <div class="bc-footer__bars">
          <div v-for="i in 12" :key="'fb-' + i" class="bc-footer__bar" :style="{ height: ((i - 1) % 3 + 1) * 20 + 'px' }"></div>
        </div>
      </div>
      <div class="bc-inner bc-footer__main">
        <div class="bc-footer__left">
          <img :src="footerLogoUrl" alt="" class="bc-footer__logo" />
          <p class="bc-footer__copy">© 2026 Trampoline World Championships Nanjing</p>
          <p class="bc-footer__sub">Hosted in Nanjing Jiangbei New Area | November 5-8, 2026</p>
        </div>
        <div class="bc-footer__right">
          <h3>Stay tuned!</h3>
          <div class="bc-footer__social">
            <a href="#" class="bc-footer__soc" aria-label="Facebook" @click.prevent="footerComingSoon">
              <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                <path
                  d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
                />
              </svg>
            </a>
            <a href="#" class="bc-footer__soc" aria-label="Instagram" @click.prevent="footerComingSoon">
              <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                <path
                  d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
                />
              </svg>
            </a>
            <a href="#" class="bc-footer__soc" aria-label="YouTube" @click.prevent="footerComingSoon">
              <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                <path
                  d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"
                />
              </svg>
            </a>
            <a href="#" class="bc-footer__soc" aria-label="X" @click.prevent="footerComingSoon">
              <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                <path
                  d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div class="bc-inner bc-footer__links">
        <button type="button" @click="footerComingSoon">Privacy Policy</button>
        <span>|</span>
        <button type="button" @click="footerComingSoon">Terms &amp; Conditions</button>
        <span>|</span>
        <button type="button" @click="footerComingSoon">Contact Us</button>
        <span>|</span>
        <button type="button" @click="footerComingSoon">Media</button>
      </div>
    </footer>


    <el-dialog
        title="提示"
        :visible.sync="centerDialogVisible"
        width="30%"
        center
    >
      <span>正在建设中~</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false"
        >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
        title="公众号二维码"
        :visible.sync="wechatDialogVisible"
        width="300px"
        center
    >
      <div class="tc">
        <!-- <img :src="require('../../assets/images/contact/mini-content.jpg')" alt=""> -->
        <img style="width:100%" :src="require('../../assets/images/contact/cca-2.png')" alt="">
      </div>
      <span slot="footer" class="dialog-footer">
      </span>
    </el-dialog>


  </div>
</template>
<script>
import BcSlideMenu from './BcSlideMenu.vue';
import { BC_SLIDE_MENU_BG, getBcIndexLogoUrl, getBcSlideMenuItems, navigateSlideMenuItem } from './bcSlideMenuConfig';

export default {
  name: "IndexLayout",
  components: {
    BcSlideMenu,
  },
  data() {
    return {
      centerDialogVisible: false,
      wechatDialogVisible: false,
      loginshow: true,
      user: {
        id: 0,
        name: "",
      },
      activity: {},
      contactList: [
        {title: "啦啦操分会<br />官方网站", desc: "www.ccachina.net"},
        {title: "啦啦操分会<br />微信公众号", desc: "最新最全的啦啦操通知"},
        {title: "啦啦操GO<br />APP", desc: "啦啦操一站式服务APP"},
        {title: "啦啦操GO<br />微信公众号", desc: "啦啦操一站式服务服务号"},
        {title: "啦啦之星<br />小程序", desc: "啦啦操线上教学小程序"},
        {title: "啦啦之星<br />微信公众号", desc: ""},
      ],
      layoutMenuOpen: false,
      navDataArr: [
        // {
        //   name: "首页",
        //   class: "",
        //   // path: "/indexpc",
        //   path: "/sai-data-list",
        // },
        // {name: "组织结构", class: "", path: "/organization"},
        { name: "通知公告", class: "", path: "/notice-list", menuIcon: "bell" },
        { name: "赛事报名", class: "", path: "/sai-data-list", menuIcon: "ticket" },
        { name: "个人中心", class: "", path: "/isai-apply-list", menuIcon: "users" },
        // {name: "活动播报", class: "", path: "/"},
        // {name: "证书查询", class: "", path: "/"},
        // {name: "新闻资讯", class: "", path: "/"},
        // {name: "地方动态", class: "", path: "/"},
        // {name: "赞助合作", class: "", path: "/"},
        // {name: "联系我们", class: "", path: "/"},
        // {name: "资料下载", class: "", path: "/"},
        // {name: "推荐商城", class: "", path: "/"},
      ],
      headerNavIconArr: [
        {
          name: "登录",
          src: require("@/assets/images/mainindex/gerenzhongxin.png"),
        },
        // {name: "查询", src: require("@/assets/images/mainindex/sousuo.png")},
        {
          name: "微信公众号",
          src: require("@/assets/images/mainindex/weixin.png"),
        },
        {
          name: "啦啦操GO",
          src: require("@/assets/images/mainindex/app-logo.png"),
        },
      ],
      headerNavIconArr2: [
        {
          name: "登录22",
          src: require("@/assets/images/mainindex/gerenzhongxin.png"),
        },
        // {name: "查询", src: require("@/assets/images/mainindex/sousuo.png")},
      ],
    };
  },
  watch: {
    loginshow(val, oldVal) {
      console.log("loginshow: " + val, oldVal);
    },
    $route: {
      handler(to) {
        console.log(to.path);
        this.handleSetRouteClass(to.path);
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    hideIndexChrome() {
      return this.$route.meta && this.$route.meta.hideIndexChrome === true;
    },
    currentLocaleLabel() {
      return this.$getLocale() === 'zh-CN' ? this.$T('中文') : this.$T('英文');
    },
    slideMenuBg() {
      return BC_SLIDE_MENU_BG;
    },
    slideMenuItems() {
      return getBcSlideMenuItems();
    },
    footerLogoUrl() {
      return getBcIndexLogoUrl();
    },
  },
  mounted() {
  },
  created() {
    // if (localStorage.getItem("_token")) {
    //   this.loginshow = false;
    // }

    this.getUser();
    this.getActivity();

    // 初次进入和刷新页面 判断激活菜单
    this.handleSetRouteClass(this.$route.path)

    console.log('window.location', this.$route.path, window.name)

  },
  methods: {
    linkDownload(url) {
      window.open(url, '_blank') // 新窗口打开外链接
    },
    logo() {
      this.handleSetRouteClass(0)
      this.$router.push({path: "/indexpc"});
    },
    action(index) {
      console.log(index);
      if (index == 0) {
        this.$router.push({path: "/login"});
      } else if (index == 2) {
        // 显示公众号二维码
        this.wechatDialogVisible = true
      }  else if (index == 3) {
        // 显示公众号二维码
        window.location.href = "http://fir.dierqudao.com/859v"
      } else {
        // todo
        this.$router.push({path: "/cha"});
      }
    },
    getUser() {
      let that = this;
      that.$api.post(
          "/api/index/userdata",
          {},
          (r) => {
            that.user = r.data;
          },
          (r) => {
            // this.$router.replace({path: "/Login"});
            // that.$message.error(r.msg);
          }
      );
    },
    getActivity() {
      let that = this;
      that.$api.post(
          "/api/index/pcIndexActivity",
          {},
          (r) => {
            that.activity = r.data;
          },
          (r) => {
            // that.$message.error(r.msg);
          }
      );
    },
    logout() {
      let that = this;
      this.$confirm("确定退出吗？")
          .then((_) => {
            that.$api.post("/api/index/logout", {}, (r) => {
              localStorage.removeItem("_token");
              that.$router.push({name: "Login"});
              location.reload()
            });
          })
          .catch((_) => {
          });
    },

    toOldWeb() {
      window.location.href = "http://www.ccachina.net/global_index_index2"
    },
    headerNavClickFun(index, val) {

      // alert(1212)

      // this.$message.info('即将开放，敬请期待...');
      // this.$router.push({path: '/'});
      // return 
      // if (index == 1 || index == 2 || index == 3 && false) {
      if (false) {
        this.centerDialogVisible = true;
      } else {
        if (val.class != "") {
          return;
        }
        this.$router.push({path: val.path});
      }
    },

    // 设置当前激活的导航显示
    handleSetRouteClass(path) {
      this.navDataArr.map((item) => {
        item.class = "";

        if (item.path == path) {
          item.class = "header_direct_leftNav_item_active";
        }
      });
    },
    footerComingSoon() {
      this.$message.info(this.$T('敬请期待'));
    },
    layoutGoHome() {
      this.$router.push({ path: '/indexpc' });
    },
    layoutGoApplyList() {
      this.$router.push({ path: '/isai-apply-list' });
    },
    layoutSetLangEn() {
      if (typeof this.$setLocale === 'function') {
        this.$setLocale('en-US');
      }
      window.location.reload();
    },
    layoutSetLangZh() {
      if (typeof this.$setLocale === 'function') {
        this.$setLocale('zh-CN');
      }
      window.location.reload();
    },
    onLayoutSlideMenuSelect(item) {
      if (navigateSlideMenuItem(this.$router, item)) {
        this.handleSetRouteClass(item.path);
        return;
      }
      this.$message.info(this.$T('敬请期待'));
    },
  },
};
</script>
<style lang="scss" scoped>
.il-bc-chrome {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background: #1a1f3a;
  position: relative;
  z-index: 55;
}

.others_header {
  width: 100%;
}

/* 与 IndexPc 顶栏、侧栏一致 */
.bc-top-nav {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 50;
  padding: 32px;
  opacity: 1;
  transform: translateX(0);
}
.bc-top-nav__inner {
  display: flex;
  align-items: center;
  gap: 24px;
}
.bc-lang {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(12px);
}
.bc-lang__btn {
  border: none;
  background: transparent;
  color: #fff;
  padding: 6px 16px;
  border-radius: 999px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: background 0.2s, color 0.2s;
}
.bc-lang__btn:hover {
  color: #e5e7eb;
}
.bc-lang__btn--active {
  background: #fff;
  color: #1a1f3a;
}
.bc-apply-records-btn {
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(12px);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  transition: background 0.2s, color 0.2s;
}
.bc-apply-records-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  color: #e5e7eb;
}
.bc-menu-trigger {
  border: none;
  cursor: pointer;
  padding: 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(12px);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  color: #fff;
}
.bc-menu-trigger:hover {
  background: rgba(255, 255, 255, 0.2);
}
.bc-menu-trigger__icon {
  width: 24px;
  height: 24px;
  display: block;
  flex-shrink: 0;
}

/* 内页 Hero：仅背景 + Logo（无运动员、无标题大图） */
.bc-hero--inner {
  position: relative;
  width: 100%;
  min-height: 130px;
  overflow: hidden;
}
.bc-hero--inner .bc-hero__bg {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0;
}
.bc-hero--inner .bc-hero__bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.bc-hero--inner .bc-hero__logo {
  position: absolute;
  top: 50%;
  left: 5%;
  z-index: 30;
  width: 42vw;
  max-width: 300px;
  transform: translateY(-50%);
  opacity: 1;
}
.bc-hero__logo-btn {
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  display: block;
  width: 100%;
}
.bc-hero--inner .bc-hero__logo img {
  width: 100%;
  height: auto;
  display: block;
}

@media (max-width: 768px) {
  .bc-top-nav {
    padding: 16px;
  }
  .bc-hero--inner {
    min-height: 180px;
  }
  .bc-hero--inner .bc-hero__logo {
    max-width: 220px;
  }
}

.bc-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding-left: 32px;
  padding-right: 32px;
}

.bc-footer {
  position: relative;
  background: linear-gradient(135deg, #2b7bbf 0%, #5fb87d 55%, #ffd93d 100%);
  padding: 64px 0 40px;
  overflow: hidden;
}
.bc-footer__deco {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0.2;
  pointer-events: none;
}
.bc-footer__wave {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 128px;
}
.bc-footer__circle {
  position: absolute;
  border-radius: 50%;
}
.bc-footer__circle--1 {
  top: 80px;
  right: 20%;
  width: 96px;
  height: 96px;
  border: 4px solid rgba(255, 217, 61, 0.4);
}
.bc-footer__circle--2 {
  top: 128px;
  right: 15%;
  width: 64px;
  height: 64px;
  background: rgba(95, 184, 125, 0.45);
}
.bc-footer__circle--3 {
  bottom: 80px;
  left: 10%;
  width: 80px;
  height: 80px;
  border: 4px solid rgba(43, 123, 191, 0.4);
}
.bc-footer__bars {
  position: absolute;
  top: 64px;
  right: 30%;
  display: flex;
  gap: 4px;
}
.bc-footer__bar {
  width: 4px;
  background: rgba(255, 217, 61, 0.35);
}
.bc-footer__main {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  align-items: start;
  margin-bottom: 32px;
}
@media (max-width: 768px) {
  .bc-footer__main {
    grid-template-columns: 1fr;
  }
  .bc-footer__right {
    align-items: flex-start !important;
  }
}
.bc-footer__logo {
  height: 64px;
  width: auto;
}
.bc-footer__copy,
.bc-footer__sub {
  color: rgba(255, 255, 255, 0.92);
  font-size: 14px;
  margin: 8px 0 0;
}
.bc-footer__right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
}
.bc-footer__right h3 {
  margin: 0;
  color: #fff;
  font-size: 20px;
  font-weight: 600;
}
.bc-footer__social {
  display: flex;
  gap: 12px;
}
.bc-footer__soc {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  transition: background 0.2s;
}
.bc-footer__soc:hover {
  background: rgba(255, 255, 255, 0.32);
}
.bc-footer__links {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px 20px;
  padding-top: 32px;
  border-top: 1px solid rgba(255, 255, 255, 0.25);
  color: rgba(255, 255, 255, 0.85);
  font-size: 14px;
}
.bc-footer__links button {
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  padding: 0;
}
.bc-footer__links button:hover {
  color: #fff;
}

</style>



// WEBPACK FOOTER //
// IndexLayout.vue?005c5077